export default "/images/80fccc2f94cf1aa184b5fdf947341034.avif";